import type { HttpClient } from '@shared/http/http-client';
import type { IScanConnectionRepository } from '@domain/data-contracts/scan-connection-repository.interface';
import type { ScanConnection } from '@domain/models/scan-connection.interface';
import { ScanConnectionStatus } from '@domain/models/scan-connection.interface';

interface ScanConnectionDto {
  readonly connectionId: string;
  readonly displayName: string;
  readonly scanProviderType: string;
  readonly integrationMethod: string;
  readonly isActive: boolean;
}

function mapScanConnectionDto(
  dto: ScanConnectionDto,
  orgId: string,
  orgName: string,
): ScanConnection {
  return {
    id: String(dto.connectionId),
    orgId,
    orgName,
    displayName: dto.displayName,
    provider: dto.scanProviderType,
    method: dto.integrationMethod,
    status: dto.isActive ? ScanConnectionStatus.Active : ScanConnectionStatus.Inactive,
  };
}

export class ScanConnectionRepository implements IScanConnectionRepository {
  public constructor(private readonly http: HttpClient) {}

  public async listForOrg(orgId: string, orgName: string, signal?: AbortSignal): Promise<readonly ScanConnection[]> {
    const response = await this.http.get<readonly ScanConnectionDto[]>(
      `/api/ScanProviderConnection?organizationId=${encodeURIComponent(orgId)}`,
      { signal },
    );
    return response.data.map((dto) => mapScanConnectionDto(dto, orgId, orgName));
  }
}
